/**
 * @generated SignedSource<<d3317de3035abff373cfc11340511033>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type NftCmsExhibitionFormat = "html" | "static" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type HeroBannerCarousel_cmsNftExhibitionPage$data = {
  readonly heroBanner: ReadonlyArray<{
    readonly format: NftCmsExhibitionFormat | null;
    readonly " $fragmentSpreads": FragmentRefs<"HeroBannerItem_heroBannerItemExhibition">;
  } | null> | null;
  readonly " $fragmentType": "HeroBannerCarousel_cmsNftExhibitionPage";
};
export type HeroBannerCarousel_cmsNftExhibitionPage$key = {
  readonly " $data"?: HeroBannerCarousel_cmsNftExhibitionPage$data;
  readonly " $fragmentSpreads": FragmentRefs<"HeroBannerCarousel_cmsNftExhibitionPage">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "HeroBannerCarousel_cmsNftExhibitionPage",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "NftCmsExhibitionHeroBannerType",
      "kind": "LinkedField",
      "name": "heroBanner",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "format",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "HeroBannerItem_heroBannerItemExhibition"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "NftCmsExhibitionPage",
  "abstractKey": null
};

(node as any).hash = "692981db5cb4a1a274aa9e5ba21252be";

export default node;
